import { createApp } from 'vue'
import options from './FactBox.options'

const el = '.kb-component--fact-box'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((factbox) => {
            if (factbox.hasAttribute('data-v-app')) return false

            const factBoxContentElement = factbox.querySelector(
                '.kb-fact-box__content'
            )
            const component = createApp(options, {
                factBoxContentId: factBoxContentElement.id
            }).use(Store)
            component.mount(factbox)

            factbox.querySelectorAll('a').forEach((a) => {
                a.setAttribute('tabindex', -1)
            })
        })
    }
}
